import { useEffect, useState } from 'react';
import { ALE_CONFIG } from '../config';

// Detecta "celular" pelo breakpoint do projeto (≤768px), reagindo a redimensionamento.
export function useIsMobile(breakpoint = ALE_CONFIG.mobileBreakpoint) {
  const getMatch = () =>
    typeof window !== 'undefined' && window.innerWidth <= breakpoint;

  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    const onResize = () => setIsMobile(getMatch());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);

  return isMobile;
}
